module.exports = "/images/essentials.jpg";